import axiosInstance from "./AxiosConfig";

class ImageApi {
  async GetImageById(id) {
    
    try {
      const response = await axiosInstance.get(`/image/${id}`, {
        responseType: "blob", // Set response type to blob
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ImageApi();
